import { Spinner, VStack } from '@chakra-ui/react';
import { useReceivedMothly } from '@partiu/api/bookstore/hooks';
import { useMemo } from 'react';
import { FaFrown } from 'react-icons/fa';
import { SectionTitle } from '../../../../../../packages/ui/components/atoms/Title';
import { useTheme } from '../../../../../../packages/ui/contexts/ThemeProvider';
import { BookCard } from '../../../components/molecules/BookCard';
import { SliderComponent } from '../../../components/molecules/HorizontalBooks';
import { Labeled } from '../../../../../../packages/ui/components/molecules/Labeled';

export function ReceivedBooksTemplate({
  description = '',
  filter,
}: {
  description: string;
  filter: Record<string, string>;
}) {
  const { data: receivedBooks, isLoading } = useReceivedMothly(filter);
  const { bookstoreLabels, colors } = useTheme();

  const resultComponent = useMemo(
    () => (
      <VStack width={'100%'} paddingBottom={'100px'}>
        {receivedBooks?.length === 0 && !isLoading && (
          <VStack paddingTop={'50px'} spacing={5}>
            <FaFrown size="36px" />
            <SectionTitle color="black">Nenhum item encontrado!</SectionTitle>
          </VStack>
        )}
        {isLoading ? (
          <VStack width="100%" mt="15px">
            <Spinner size="lg" color={colors.primaryColor} />
          </VStack>
        ) : null}
        {description && (receivedBooks?.length ?? 0) > 0 && (
          <Labeled labelSize="24px" paddingX="5%" labelColor="rgba(0,0,0,0.6)" label={''} helpText={description} />
        )}
        {receivedBooks?.map((book) => (
          <VStack width="100%" key={`${book.label}`} mt="15px">
            <SliderComponent size={book.books.length} name={book.label} description={''}>
              {({ currentSlide }) =>
                book.books?.map((b, index) => (
                  <BookCard receivedBook isActive={currentSlide === index} key={b.book.id} book={b.book} />
                ))
              }
            </SliderComponent>
          </VStack>
        ))}
      </VStack>
    ),
    [bookstoreLabels.singular, isLoading, receivedBooks]
  );

  return resultComponent;
}
